import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Route, Routes, Navigate  } from "react-router-dom";
import { checkEmpty, clearStorage, getStorage, getStorageJson, setAuthStorage, setBasicdataStorage } from "../helpers/utility";
import { checkLogin } from "../redux/slices/AuthSlice";
import Loader from "../shade/Loaders/Loaders"
import AuthProtectedRoute from "./AuthProtectedRoute";
import { getBasicdata } from "../redux/slices/BasicDataSlice";


// import pabitraRouteConfig from "./PabitraRoutesConfig";
import asitRouteConfig from "./AsitRoutesConfig";



const App = React.lazy(() => import("../shade/layouts/App"));
//const Switcherapp = React.lazy(() => import("../shade/layouts/Switcherapp"));
const Custompages = React.lazy(() => import("../shade/layouts/custompages"));


const AuthLogin = React.lazy(() => import("../pages/auth/Login"));




const SignUp = React.lazy(() =>
  import("../pages/Authentication/SignUp/SignUp")
);
const SignIn = React.lazy(() =>
  import("../pages/Authentication/SignIn/SignIn")
);
const ForgotPassword = React.lazy(() =>
  import("../pages/Authentication/ForgotPassword/ForgotPassword")
);
const Lockscreen = React.lazy(() =>
  import("../pages/Authentication/Lockscreen/Lockscreen")
);
const ResetPassword = React.lazy(() =>
  import("../pages/Authentication/ResetPassword/ResetPassword")
);
const UnderConstruction = React.lazy(() =>
  import(
    "../pages/Authentication/UnderConstruction/UnderConstruction"
  )
);
const Error404 = React.lazy(() =>
  import("../pages/Authentication/404Error/404Error")
);
const Error500 = React.lazy(() =>
  import("../pages/Authentication/500Error/500Error")
);




//Utilities end
//Icons
const FontAwesome = React.lazy(() =>
  import("../pagecomponents/Icons/FontAwesome/FontAwesome")
);
const MaterialIcons = React.lazy(() =>
  import("../pagecomponents/Icons/MaterialIcons/MaterialIcons")
);
const MaterialDesignIcons = React.lazy(() =>
  import("../pagecomponents/Icons/MaterialDesignIcons/MaterialDesignIcons")
);
const IonicIcons = React.lazy(() =>
  import("../pagecomponents/Icons/IonicIcons/IonicIcons")
);
const Pe7Icons = React.lazy(() =>
  import("../pagecomponents/Icons/Pe7Icons/Pe7Icons")
);
const SimpleLineIcons = React.lazy(() =>
  import("../pagecomponents/Icons/SimpleLineIcons/SimpleLineIcons")
);
const ThemifyIcons = React.lazy(() =>
  import("../pagecomponents/Icons/ThemifyIcons/ThemifyIcons")
);
const TypiconsIcons = React.lazy(() =>
  import("../pagecomponents/Icons/TypiconsIcons/TypiconsIcons")
);
const WeatherIcons = React.lazy(() =>
  import("../pagecomponents/Icons/WeatherIcons/WeatherIcons")
);
const BootstrapIcons = React.lazy(() =>
  import("../pagecomponents/Icons/BootstrapIcons/BootstrapIcons")
);
const FeatherIcons = React.lazy(() =>
  import("../pagecomponents/Icons/FeatherIcons/FeatherIcons")
);
const FlagIcons = React.lazy(() =>
  import("../pagecomponents/Icons/FlagIcons/FlagIcons")
);
//Icons end
//Form




const Routers = () => {

  // console.log('Router.js=> checklogin and startup apis called here');
  // const dispatch = useDispatch();
  // let config = getStorageJson('config');
  // useEffect(() => {
  //   if (!checkEmpty(config.userdata)) {
  //     let checkLoginPayload = { "inputData": { "uuid": getStorage('uuid'), "jjpi": getStorage('jjpi'), "deviceId": "" }, "deviceData": [], "fireBaseNotification": null }
  //     dispatch(checkLogin(checkLoginPayload)).then(({ payload }) => {
  //       if (payload.status === 'success') {
  //         setAuthStorage(payload);
  //         dispatch(getBasicdata({})).then(({ payload }) => {
  //           if (payload.status === 'success') {
  //             setBasicdataStorage(payload);
  //           }
  //         });

  //       } else {
  //         console.log('checklogin failed - logging out');
  //         clearStorage();
  //         window.location.reload(false);
  //       }
  //     });
  //   }
  //   return () => { };
  // }, [dispatch, config]);

 

  // const generatePabitraRoutes = (developer) => {
  //   return pabitraRouteConfig[developer].map((route, index) => (
  //     <Route key={index} path={route.path} element={<route.component/>} />
  //   ));
  // };

  const generateAsitRoutes = (developer) => {
    return asitRouteConfig[developer].map((route, index) => (
      <Route key={index} path={route.path} element={<route.component/>} />
    ));
  };


  return (
    <BrowserRouter>
      <React.Suspense fallback={<Loader />}>
        <Routes>
          <Route
            path={`${process.env.PUBLIC_URL}/authentication/login`}
            element={<AuthLogin />}
          />
          <Route element={<AuthProtectedRoute />}>
            <Route path={`${process.env.PUBLIC_URL}/`} element={<App />}> 
            <Route path="/" element={<Navigate to="/job/" />} />
                          
              {/* {generatePabitraRoutes('router_pabitra')} */}
              {generateAsitRoutes('router_asit')}

              {/* <Route>
                <Route
                  path={`${process.env.PUBLIC_URL}/job/job`}
                  element={<Dashboard />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/dashboard/dashboard-2`}
                  element={<Dashboard2 />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/dashboard/dashboard-3`}
                  element={<Dashboard3 />}
                />
              </Route> */}


            </Route>
          </Route>
          
          <Route path={`${process.env.PUBLIC_URL}/`} element={<Custompages />}>
            <Route
              path={`${process.env.PUBLIC_URL}/pages/Authentication/sigin`}
              element={<SignIn />}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/pages/Authentication/sigup`}
              element={<SignUp />}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/pages/Authentication/forgotpassword`}
              element={<ForgotPassword />}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/pages/Authentication/resetpassword`}
              element={<ResetPassword />}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/pages/Authentication/lockscreen`}
              element={<Lockscreen />}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/pages/Authentication/underconstruction`}
              element={<UnderConstruction />}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/pages/Authentication/404error`}
              element={<Error404 />}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/pages/Authentication/500error`}
              element={<Error500 />}
            />
            <Route path="*" element={<Error404 />} />
          </Route>
          {/* <Route>
            <Route
              path={`${process.env.PUBLIC_URL}/pages/switcher/switcher-1`}
              element={<Switcherapp />}
            />
          </Route> */}
          <Route></Route>
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default Routers;